import {
    type ChangeClassificationAction,
    type ClassificationState,
    SELLSCREEN_CLASSIFICATION_CHANGE,
} from "../../Actions/SellScreen/SellScreenClassificationActions";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

function SellScreenClassificationReducer(
    state: ClassificationState,
    action: ShopfrontActions<ChangeClassificationAction>
): ClassificationState {
    if(typeof state === "undefined") {
        return {
            type  : null,
            uuid  : null,
            isCase: false,
        };
    }

    switch(action.type) {
        case SELLSCREEN_CLASSIFICATION_CHANGE:
            return {
                type  : action.classification,
                uuid  : action.uuid,
                isCase: action.isCase,
            };
        default:
            return state;
    }
}

export default SellScreenClassificationReducer;
